<template>
  <AttachmentForm :attachments="attachments"></AttachmentForm>
</template>

<script>
import AttachmentForm from './AttachmentForm'
import { mapActions } from 'vuex'

export default {
  name: 'work-request-attachments',
  components: {
    AttachmentForm
  },
  props: {
    workRequestId: [Number, String]
  },
  mounted() {
    this.updateWorkRequestAttachments({
      workRequestId: this.workRequestId
    })
  },
  computed: {
    attachments() {
      return this.$store.getters.attachments
    }
  },
  methods: {
    ...mapActions(['updateWorkRequestAttachments'])
  }
}
</script>